// ----------------------------
// Created by Bulletproof Games
//            2018
//  www.bulletproofgames.co.uk
// ----------------------------

excitementManager = {};
excitementManager.level = 0;

excitementManager.addExcitement = function() {
};

excitementManager.fullExcitement = function() {
    while (excitementManager.level < 7) {
        excitementManager.addExcitement();
    }
};

excitementManager.clear = function() {
    excitementManager.level = 0;

};





